import { useLocalization } from "@tm/localization"
import { useSelector } from "react-redux"
import { useMemo } from "react"
import { Box, CellContentPosition, Loader, Table, TableColumnData, TableRowData, Typography } from "@tm/components"
import { vehicleSelector } from "../../../../data/helpers"
import { MainState } from "../../../main"

const Wrapper = ({ children }: { children: React.ReactNode }) => {
    const { translateText } = useLocalization()

    return (
        <Box>
            <Typography variant="h1" marginBottom="0.5em">
                {translateText(931)}
            </Typography>
            {children}
        </Box>
    )
}

export default function RimVehicleInfoLKQ() {
    const { translateText } = useLocalization()
    const vehicle = useSelector(vehicleSelector)
    const {
        additionalVehicleInfosResult: { data, error, loading },
    } = useSelector((s: MainState) => ({ additionalVehicleInfosResult: s.wheelsList.base.vehicleInfosResult }))
    const { selectedRegistrationNo } = useSelector((s: MainState) => s.vehicleSelection)

    const additionalInfoRows: TableRowData[] = data.map((info) => ({
        id: info.attributeId.toString(),
        cells: [
            { id: "1", displayValue: info.description },
            { id: "2", displayValue: info.attributeValue },
        ],
    }))

    const vehicleInfoRows: TableRowData[] = useMemo(
        () => [
            ...((selectedRegistrationNo && [
                {
                    id: "registrationNo",
                    cells: [
                        { id: "1", displayValue: translateText(1730) },
                        { id: "2", displayValue: vehicle?.registrationNo },
                    ],
                },
            ]) ||
                []),
            {
                id: "manufacturer",
                cells: [
                    { id: "1", displayValue: translateText(71) },
                    { id: "2", displayValue: vehicle?.manufacturer },
                ],
            },
            {
                id: "engineCode",
                cells: [
                    { id: "1", displayValue: translateText(105) },
                    { id: "2", displayValue: vehicle?.engineCode },
                ],
            },
            {
                id: "model",
                cells: [
                    { id: "1", displayValue: translateText(74) },
                    { id: "2", displayValue: vehicle?.model },
                ],
            },
            {
                id: "modelSeries",
                cells: [
                    { id: "1", displayValue: translateText(73) },
                    { id: "2", displayValue: vehicle?.modelSeries },
                ],
            },
            {
                id: "vin",
                cells: [
                    { id: "1", displayValue: translateText(101) },
                    { id: "2", displayValue: vehicle?.vin },
                ],
            },
        ],
        [selectedRegistrationNo]
    )

    function getColumns() {
        const columns: TableColumnData[] = [
            { alignContent: CellContentPosition.left, overflowCell: true },
            { alignContent: CellContentPosition.right, overflowCell: true },
        ]

        return columns
    }

    if (loading) {
        return (
            <Wrapper>
                <Loader />
            </Wrapper>
        )
    }

    if (error || !data.length || !vehicle) {
        return (
            <Wrapper>
                <Typography size="h1"> {translateText(163)}</Typography>
            </Wrapper>
        )
    }

    return (
        <Wrapper>
            <Box display="flex">
                <Table rows={vehicleInfoRows} columns={getColumns()} headerStyle="hidden" fontSize={15} rowStyle="uniform" />
                <Table rows={additionalInfoRows} columns={getColumns()} headerStyle="hidden" fontSize={15} rowStyle="uniform" />
            </Box>
        </Wrapper>
    )
}
